import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';
import { EmpresasUsuario } from 'src/app/Modelos/empresas_usuario';
import { VariablesService } from 'src/app/Servicios/variables.service';
import { Router } from '@angular/router';
import { ServiciosService } from 'src/app/Servicios/servicios.service';

@Component({
  selector: 'app-empresas-usuario',
  templateUrl: './empresas-usuario.component.html',
  styleUrls: ['./empresas-usuario.component.scss'],
})
export class EmpresasUsuarioComponent implements OnInit {

  public listado: EmpresasUsuario[];

  constructor(
    public servicios : ServiciosService,
    private variables: VariablesService,
    private modaCtrl :ModalController,
    private router : Router,
    private navParams: NavParams,
    private popoverCtrl: PopoverController
  ) {
    //console.log("listaEmpresas", this.listado, this.navParams.data.listaEmpresas)
   }

  ngOnInit() {
    this.listado = this.navParams.data.listaEmpresas;
  }

  empresaSeleccionada(empresa : EmpresasUsuario) {
    this.variables.empresaSeleccionada = empresa;
    //console.log(" en empresas component" , this.variables.empresaSeleccionada);
    this.modaCtrl.dismiss();
   // this.variables.empresaSeleccionada = this.listaEmpresas[0];
          //console.log("empresa selecionada cuando es una" , this.variables.empresaSeleccionada);
          
    this.router.navigate(['tabs'])

  }

  

}
